export enum TranslationISO {
    en = 'en-US',
    es = 'es-MX',
}

export const LanguageCodeToNgTranslateMapping = {
    en: 'en',
    es: 'es',
};

export const PatientLocaleToLanguageCodeMapping = {
    'es-MX': 'es',
    'en-US': 'en',
};

export interface TranslateLanguage {
    name: string;
    code: TranslationISO;
}
